// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout-module--container--2EaUW","themeSwitcher":"Layout-module--theme-switcher--2I-25","main":"Layout-module--main--1OIFf"};